// extracted by mini-css-extract-plugin
export default {"container":"Fo-z","heading":"Go-z","text":"Ho-z","info":"Io-z","link":"Jo-z","fullMaxWidth":"Ko-z"};